import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../utils/QueryKeys';
import { Package, Price } from '../models';

// Senior-flavored equivalent of usePastImagesQuickOrderPricelist. Loads the
// HS senior past-images Quick Order pricelist (slug='past_images_quick_order_senior')
// scoped to the school, with everything the senior Quick Order page needs:
// options + image types + prices + background set + package_poses.
//
// Returns null when the school has no senior package attached — the
// PreviousImages router uses that to decide between the elementary and the
// senior Quick Order routes.
export default function usePastImagesSeniorQuickOrderPricelist(schoolId) {
  return useQuery({
    queryKey: [QueryKeys.pastImagesSeniorQuickOrder, QueryKeys.pricelist, schoolId],
    queryFn: () => (
      Package
        .selectExtra(['defaultBackgroundUrl'])
        .includes({
          backgroundSet: 'backgrounds',
          options: ['image_types', 'prices'],
          package_poses: 'background',
        })
        .merge({ prices: Price.where({ for_school: schoolId }) })
        .where({ pastImagesQuickOrderSenior: true })
        .where({ schoolId })
        .all()
        .then((res) => (res.data && res.data[0]) || null)
    ),
    placeholderData: null,
    staleTime: 60_000,
    enabled: !!schoolId,
  });
}
